import { FC } from "react"
import { ItemCheckboxProps } from "./models"
import { FormItem } from ".."
import { Checkbox } from "../../../Checkbox"

export const ItemCheckbox: FC<ItemCheckboxProps> = (props) => {
  const {
    checked,
    isBgBlue,
    isHiddenLabel,
    extra,
    label,
    name,
    onChange,
    required,
    rules,
    text,
    tooltip,
    ...res
  } = props

  return (
    <FormItem
      className="ant-form-item-checkbox"
      isBgBlue={isBgBlue}
      extra={extra}
      label={label}
      name={name}
      required={required}
      rules={rules}
      tooltip={tooltip}
      valuePropName="checked"
      {...res}
    >
      <Checkbox
        checked={checked}
        isHiddenLabel={isHiddenLabel}
        onChange={onChange}
        text={text}
      />
    </FormItem>
  )
}
